function initAccordion(item) {
  if (item.dataset.initialized) return;
  item.dataset.initialized = 'true';

  const trigger = item.querySelector('.el-accordion__question');
  const content = item.querySelector('.el-accordion__answer');

  if (!trigger || !content) return;

  content.style.height = '0px';
  content.style.overflow = 'hidden';
  content.style.paddingBottom = '0px';

  trigger.addEventListener('click', () => {
    const isOpen = item.classList.contains('is-open');

    document.querySelectorAll('.el-accordion.is-open')
      .forEach(openItem => {
        openItem.classList.remove('is-open');

        const c = openItem.querySelector('.el-accordion__answer');
        if (!c) return;

        c.style.height = '0px';
        c.style.paddingBottom = '0px';
      });

    if (!isOpen) {
      item.classList.add('is-open');

      requestAnimationFrame(() => {
        content.style.height = content.scrollHeight + 23 + 'px';
        content.style.paddingBottom = '23px';
      });
    }
  });
}

document.querySelectorAll('.el-accordion').forEach(initAccordion);